export default {
  dbh_nav_show_new_version_default: 'Show New Beta By Default',
  dbh_nav_back_to_old: 'If you want to switch to old version, deselect the default settings first.',
  dbh_nav_mobile_title: 'WeChat Mini Program',
  dbh_nav_chatgpt_tips: 'ChatGPT has been relocated here!',
  dbh_agent_entry_fullscreen_mode: 'Full-screen Mode',
  dbh_agent_entry_copilot_mode: 'Copilot Mode',
  dbh_nav_agent_tip_title: 'Agent: Your game data AI expert.',
  dbh_nav_agent_tip_desc: 'DataBrain ChatGPT services are moving to Brainy. Access Agents & models there.',
  dbh_nav_agent_tip_go_to_gpt: 'Launch GPT in Brainy',
  dbh_nav_agent_tip_feedback: 'Report an issue',
  dbh_agent_entry_already_on_agent_home: 'Already on Agent home',
};
